import React from 'react';
import { Box } from '@mui/material';
import PaymentSummary from './PaymentSummary';
import SettlementDataForm from './SettlementDataForm';

const SettlementTab = ({ updateOrders, formik }) => (
  <Box display="flex" flexDirection="column" mt={1}>
    <PaymentSummary />
    {/* <SettlementDataForm updateOrders={updateOrders} formik={formik} /> */}
  </Box>
);


export default SettlementTab;
